export enum DiagramEventObserverMask {
    ALL = -1,
    FROM_DB = 1,
    TO_DB = 2,
}